import React, { Component } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { NavLink } from "react-router-dom";
import { GridList, GridListTile, Grid } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Gallery from "react-photo-gallery";
import Carousel, { Modal, ModalGateway } from "react-images";
import "./Gallery.css";
import classNames from "classnames";
import PhotoGrid from "./PhotoGrid";
const useStyles = (theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    overflow: "hidden",
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  imgFluid: {
    maxWidth: "100%",
    height: "auto",
  },
  imgRounded: {
    borderRadius: "6px !important",
  },
  imgRoundedCircle: {
    borderRadius: "50% !important",
  },
  imgRaised: {
    boxShadow:
      "0 5px 15px -8px rgba(0, 0, 0, 0.24), 0 8px 10px -5px rgba(0, 0, 0, 0.2)",
  },
  imgGallery: {
    width: "100%",
    marginBottom: "2.142rem",
  },
  imgCardTop: {
    width: "100%",
    borderTopLeftRadius: "calc(.25rem - 1px)",
    borderTopRightRadius: "calc(.25rem - 1px)",
  },
  imgCardBottom: {
    width: "100%",
    borderBottomLeftRadius: "calc(.25rem - 1px)",
    borderBottomRightRadius: "calc(.25rem - 1px)",
  },
  imgCard: {
    width: "100%",
    borderRadius: "calc(.25rem - 1px)",
  },
  imgCardOverlay: {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    padding: "1.25rem",
  },
});
const Photos = ({ photos }) => {
  const [currentImage, setCurrentImage] = React.useState(0);
  const [viewerIsOpen, setViewerIsOpen] = React.useState(false);
  // const [photos, setPhotos] = React.useState([]);

  const openLightbox = React.useCallback((event, index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const photosMemo = React.useMemo(
    () =>
      photos.map((image, index) => {
        return {
          original: `/mop/images/${image}`,
          thumbnail: `/mop/images/${image}`,
          src: `/mop/images/${image}`,
          col: Math.floor(Math.random() * 2) + 1,
          row: Math.floor(Math.random() * 2) + 1,
          img: image,
        };
      }),
    [photos]
  );

  React.useEffect(() => {
    // setPhotos(photos);
  }, []);
  // state = {
  //   photos: this.props.photos || []
  // }
  // console.log(this.props.photos)

  // const navImageClasses = classNames(
  //   props.classes.imgRounded,
  //   props.classes.imgGallery
  // );
  return (
    <div className="container-fluid slider">
      <div>
        <Grid container>
          {/* <Gallery photos={photos} onClick={openLightbox} /> */}
          <ModalGateway>
            {viewerIsOpen ? (
              <Modal onClose={closeLightbox}>
                <Carousel
                  currentIndex={currentImage}
                  views={photosMemo.map((x) => ({
                    ...x,
                    srcset: x.srcSet,
                    caption: x.title,
                  }))}
                />
              </Modal>
            ) : null}
          </ModalGateway>
          <PhotoGrid photos={photosMemo} openLightbox={openLightbox} />
          {/* <GridList cellHeight={160} cols={3} spacing={12}>
            {photos.map((image, index) => {
              return (

                <GridListTile
                  key={image.img}
                  cols={1}
                  onClick={(e) => openLightbox(e, index)}
                >
                  <img
                    alt="..."
                    src={`/mop/images/${image.img}`}
                    className={navImageClasses}
                    loading="lazy"
                    // className={navImageClasses}
                  />
                </GridListTile>
              );
            })}
          </GridList> */}
        </Grid>
        {/* <div className="col  m-5 ">
     {photos && <ImageGallery items={photos} autoPlay={true}  />}
     
      </div> */}
        {/* <div className="col-12">
          <NavLink
            to="/mop/search"
            style={{ textDecoration: "none" }}
            activeStyle={{
              border: "1px solid #fff",
            }}
          >
            <span
              className="btn btn-primary btn-md btn-search mb-3"
              role="button"
            >
              Назад до пошуку
            </span>
          </NavLink>
        </div> */}
      </div>
    </div>
  );
};

export default withStyles(useStyles)(Photos);
